import { Component, OnInit, OnChanges, ViewChild, } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table'
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SpinnerService } from '../../shared/components/spinner/spinner.service';
import { MailingRecordService } from '../../shared/services/mailingRecord.service';
import { Mailing } from '../../shared/models/mailing';
import { MailingService } from '../../shared/services/mailing.service';

// flatfile
import FlatfileImporter from "flatfile-csv-importer";

// helper components
import { ConfirmationModalService } from '../../shared/components/modals/confirmation-modal/confirmation-modal.service';
import { interval } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DatePipe, formatDate } from '@angular/common';
import { CampaignTypeService } from '../../shared/services/campaignType.service';
import { BrandService } from '../../shared/services/brand.service';
import { Brand } from '../../shared/models/Brand';
import { CampaignType } from '../../shared/models/CampaignType';
import { MailingFileService } from '../../shared/services/mailingFile.service';
import { MailingFile } from '../../shared/models/MailingFile';
import { AuthorizeService } from '../../../api-authorization/authorize.service';
import { environment } from '../../../environments/environment';
declare var $: any;

@Component({
  selector: 'app-mailing-files',
  templateUrl: './mailing-files.component.html'
})

export class MailingFilesComponent implements OnInit {
  length = 20;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 100];
  pageEvent: PageEvent;
  dataSource = new MatTableDataSource<MailingFile>();
  displayedColumns: string[] = ['action', 'name', 'totalRecords', 'createDate'];
  public loader1 = false;
  public showMsg = false;
  private sub: any;
  private id: number; // id
  public mailing: Mailing; // mailing model
  private importer: FlatfileImporter; // flatfile importer
  public results = "[]"; //Result data from importer
  public mailingFileId = 0;
  public mailingRecords = [];
  public userName: string;
  public userId: string;
  public brands: Brand[]; // brand model to bind dropdownlist
  public campaignTypes: CampaignType[];
  public campaignTypeSelected = '';
  public brandSelected = '';
  public brandSelectOptions: any[];
  public campaignSelectOptions: any[];
  isMailingReady = false;
  campaignTypeForm: FormGroup;
  campaignTypeFormSubmitted = false;
  pipe = new DatePipe('en-US');

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private campaignTypeService: CampaignTypeService,
    private brandService: BrandService,
    private mailingFileService: MailingFileService,
    private router: Router,
    private route: ActivatedRoute,
    private notification: MatSnackBar,
    private authorizeService: AuthorizeService,
    private spinnerService: SpinnerService,
    private mailingRecordService: MailingRecordService,
    private mailingService: MailingService,
    private confirmationModalService: ConfirmationModalService,
    private datepipe: DatePipe
  ) { }


  // init
  ngOnInit() {

    // show spinner on page load
    this.spinnerService.show();

    this.campaignTypeForm = new FormGroup({
      campaignType: new FormControl(false),
      brand: new FormControl(false)
    });


    // get url parameter id 
    this.sub = this.route.params.subscribe(params => {
      this.id = +params['id']; // (+) converts string 'id' to a number

      // get mailing info
      this.getMailing(this.id);

      // get mailing files
      this.getMailingFiles(this.id);

      // get current user
      this.authorizeService.getUser().subscribe(result => {
        this.userName = result.name;
        this.userId = result.sub;
      });

      // bind brands
      this.brandService.getActiveBrands().subscribe(result => {
        if (result.length) {
          this.brands = result;// map brand options for dropdown

          // get campaign types
          this.campaignTypeService.getAll().subscribe(result => {
            this.campaignTypes = result;

            // call importer initializer
            this.initializeImporter();
          });
        }
      }, error => console.error(error));

      // hide spinner
      setTimeout(() => {
        this.spinnerService.hide();
      }, 1500);
    });
  }

  // get mailing details
  getMailing(id: number) {
    // get mailing
    this.mailingService.getById(id).subscribe(result => {

      this.mailing = result;

      // hide spinner
      setTimeout(() => {
        this.spinnerService.hide();
      }, 1500);

    }, error =>
      console.error(error)
      //  this.router.navigate(['/mailings/'])
    );
  }

  //launch flatfile importer tool
  showCampaignTypeModal(missingCampaign: boolean, missingBrand: boolean) {
    // init mailingTypeForm

    if (missingCampaign) {
      this.campaignTypeForm.setControl('campaignType', new FormControl('', Validators.required))
    } else {
      this.campaignTypeForm.removeControl('campaignType');
    }

    if (missingBrand) {
      this.campaignTypeForm.setControl('brand', new FormControl('', Validators.required));
    } else {
      this.campaignTypeForm.removeControl('brand');
    }

    this.campaignTypeForm.updateValueAndValidity();

    $('#addCampaignTypeModal').modal({ 'show': true, 'keyboard': false, 'backdrop': 'static' });
  }

  // import files
  async importDataFile() {
    try {

      let results = await this.importer.requestDataFromUser();
      this.campaignTypeSelected = ''; // reset campaign type for additional file import
      //this.spinnerService.show("Loading");

      // reset list
      this.mailingRecords = [];

      // add new mailing file and convert each record to match upload model
      this.mailingFileService.add({ name: results.fileName, mailingId: +this.mailing.id } as MailingFile)
        .subscribe(mailingFile => {

          // map data to object  
          this.mailingRecords = results.validData.map((x) => ({
            mailingFileId: mailingFile.id,
            mailingId: this.mailing.id,
            patientId: x.hasOwnProperty('patientId') ? x.patientId.trim() : '',
            clxPatientId: x.hasOwnProperty('clxPatientId') ? x.clxPatientId.trim() : '', //x.clxPatientId,
            firstName: x.hasOwnProperty('firstName') ? x.firstName.trim() : '',//x.firstName,
            lastName: x.hasOwnProperty('lastName') ? x.lastName.trim() : '', //x.lastName,
            address1: x.hasOwnProperty('address1') ? x.address1.trim() : '', //x.address1,
            address2: x.hasOwnProperty('address2') ? x.address2.trim() : '', //x.address2,
            city: x.hasOwnProperty('city') ? x.city.trim() : '', //x.city,
            state: x.hasOwnProperty('state') ? x.state.trim() : '', //x.state,
            zipCode: x.hasOwnProperty('zipCode') ? x.zipCode.trim() : '', //x.zipCode,
            gender: x.hasOwnProperty('gender') ? x.gender.trim() : 'F', //!x.gender ? 'F' : x.gender,
            brandName: x.hasOwnProperty('brandName') ? x.brandName.trim() : '', //x.brandName,
            dateOfBirth: this.convertDate(x.dateOfBirth),
            lastExamDate: this.convertDate(x.lastExamDate),
            storeLocationName: x.hasOwnProperty('storeDescription') ? x.storeDescription.trim() : '', //x.storeDescription,
            campaignTypeName: x.hasOwnProperty('campaignType') ? x.campaignType.trim() : '', //x.campaignType,
            phone: x.hasOwnProperty('phone') ? x.phone.trim() : '', //x.phone,
            email: x.hasOwnProperty('email') ? x.email.trim() : '', //x.email,
            custom1: x.hasOwnProperty('custom1') ? x.custom1.trim() : '', //x.custom1,
            custom2: x.hasOwnProperty('custom2') ? x.custom2.trim() : '', //x.custom2,
            custom3: x.hasOwnProperty('custom3') ? x.custom3.trim() : '', //x.custom3,
            custom4: x.hasOwnProperty('custom4') ? x.custom4.trim() : '', //x.custom4,
            custom5: x.hasOwnProperty('custom5') ? x.custom5.trim() : '', //x.custom5
          }));

          let isMissingCampaignType = this.mailingRecords.some(x => x.campaignTypeName === '' || x.campaignTypeName === undefined);
          let isMissingBrand = this.mailingRecords.some(x => x.brandName === undefined || x.brandName === '');

          // assign id of new mailingfile
          this.mailingFileId = mailingFile.id;
          if (isMissingCampaignType || isMissingBrand) {
            this.showCampaignTypeModal(isMissingCampaignType, isMissingBrand);
          } else {
            this.addMailingRecords();
          }
        });

    } catch (e) {
      console.info(e || "window close");
    }
  }

  // add mailing records
  addMailingRecords() {

    this.importer.displayLoader();

    //if campaign type was set by user then assign to records
    if (this.campaignTypeSelected !== '' && this.campaignTypeSelected !== undefined) {
      this.mailingRecords.forEach(x => x.campaignTypeName = this.campaignTypeSelected);
    }
    //if brand was set by user then assign to records
    if (this.brandSelected !== '' && this.brandSelected !== undefined) {
      this.mailingRecords.forEach(x => x.brandName = this.brandSelected);
    }

    // add mailing records
    this.mailingRecordService.addBulk(this.mailingFileId, this.mailingRecords).subscribe(() => {
      //this.spinnerService.hide();

      // reset fields
      this.brandSelected = '';
      this.campaignTypeSelected = '';
      this.campaignTypeFormSubmitted = false;
      this.mailingFileId = 0;
      this.mailingRecords = [];
      this.importer.displaySuccess("Your data was successfully imported!");
      this.getMailingFiles(this.id);

      const timeIntervalSeconds = 5; // seconds
      this.isMailingReady = false;

      // get now list of mailing files every 5 seconds to refresh status 
      const timer = interval(timeIntervalSeconds * 1000).subscribe(x => {
        this.getMailingFiles(this.id);
        if (this.isMailingReady === true) {
          timer.unsubscribe();
        }
      });

    }, error => console.error(error));
  }

  // add campaign type and brand to mailing records
  addCampaignType() {
    this.campaignTypeFormSubmitted = true;

    if (this.campaignTypeForm.invalid) {
      return;
    }
    this.campaignTypeSelected = this.campaignTypeForm.value["campaignType"];
    this.brandSelected = this.campaignTypeForm.value["brand"];

    $('#addCampaignTypeModal').modal('hide');
    this.addMailingRecords();
  }

  // gets mailing records based on mailing id
  getMailingFiles(id: number): void {
    // get mailingrecords
    this.mailingFileService.getAll(id).subscribe(result => {
      //if (result.length) { 
      this.dataSource.data = result;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      //} 

      this.isMailingReady = result.every(element => element.isProcessed === true);

    }, error => console.error(error));
  }

  // delete mailing file
  deleteMailingFile(id: number) {
    this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
      .then((confirmed) => {
        if (confirmed) {
          this.mailingFileService.delete(id)
            .subscribe(() => {
              this.showNotification('This mailing file has been deleted successfully!', 'Okay!');
              this.getMailingFiles(this.mailing.id);
              //this.router.navigate(['/mailings/']);
            });
        }
      })
      .catch(() =>
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      );
  }

  // build fields configuration for flat file
  getFlatfileFields() {
    let config = [
      {
        label: 'Brand',
        key: 'brandName',
        alternates: ["member", 'brand name', 'company name', 'brand'],
        // type: 'select',
        //options: this.brandSelectOptions,
        //validators: [
        //  {
        //    validate: "required",
        //    error: "this field is required"
        //  }
        //]
      },
      {
        label: 'Patient ID',
        key: 'patientId',
        alternates: ['Pt #']
      },
      {
        label: 'CLX Patient ID',
        key: 'clxPatientId',
        alternates: ['clxPersonId'],
      }, {
        label: 'First Name',
        key: 'firstName',
        alternates: ['First'],
        validators: [
          {
            validate: "required",
            error: "this field is required"
          }
        ]
      }, {
        label: 'Last Name',
        key: 'lastName',
        alternates: ['Last'],
        validators: [
          {
            validate: "required",
            error: "this field is required"
          }
        ]
      }, {
        label: 'Address',
        key: 'address1',
        alternates: ['address', 'address_line1', 'Pt Address'],
        validators: [
          {
            validate: "required",
            error: "this field is required"
          }
        ]
      }, {
        label: 'Address 2',
        key: 'address2',
        alternates: ['address_line2'],
        // isRequired: false
      }, {
        label: 'City',
        key: 'city',
        alternates: ['address_city', 'Pt City'],
        //isRequired: false
      }, {
        label: 'State',
        key: 'state',
        alternates: ['address_state', 'ST', 'Pt State'],
        // isRequired: false
      }, {
        label: 'Zip Code',
        key: 'zipCode',
        alternates: ['address_zip', 'Zip', 'Pt Zip'],
        // isRequired: false
      }, {
        label: 'Gender',
        key: 'gender',
        alternates: ['Sex', 'Ins1 Sex']
        // isRequired: false
      }, {
        label: 'Date of Birth',
        key: 'dateOfBirth',
        alternates: ['DOB', 'Pt DOB']
        //validators: [
        //  {
        //    //regex: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/, 
        //    validate: "required",
        //    error: "this field is required"
        //  }
        //]
      }, {
        label: 'Last Exam Date',
        key: 'lastExamDate',
        alternates: ['LastExam', 'Last Eye Exam', 'last_exam_date', 'Last Visit']
        //validators: [
        //  {
        //    validate: "required",
        //    error: "this field is required"
        //  }
        //]
      }, {
        label: 'Campaign Type',
        key: 'campaignType',
        alternates: ['campaign'],
        //type: 'select',
        // options: this.campaignSelectOptions,
        //  validators: [
        // {
        //    validate: "required",
        //    error: "this field is required"
        //  }
        // ]
      },
      {
        label: 'Store Description',
        key: 'storeDescription',
        alternates: ['office_short_name', 'storeDescription', 'practiceName', 'Practice Name', 'StoreName', 'Location Plaza', 'Exam Office']
      },
      {
        label: 'Phone',
        key: 'phone',
        alternates: ['phone number', 'Pt Phone #']
      }, {
        label: 'Email',
        key: 'email',
        alternates: ['email address']
      }, {
        label: 'Custom 1',
        key: 'custom1'
      }, {
        label: 'Custom 2',
        key: 'custom2'
      }, {
        label: 'Custom 3',
        key: 'custom3'
      }, {
        label: 'Custom 4',
        key: 'custom4'
      }, {
        label: 'Custom 5',
        key: 'custom5'
      },
      // additional fields not being stored
      {
        label: 'Nickname',
        key: 'nickname'
      }, {
        label: 'Recall Type',
        key: 'recallType'
      }, {
        label: 'Recall Date',
        key: 'recallDate'
      }, {
        label: 'Full Name',
        key: 'fullName'
      }, {
        label: 'Full Address',
        key: 'fullAddress'
      }
    ];
    return config;
  }

  convertDate(s: string): string {
    let strDate = null;

    if (s !== '' && s !== undefined && s !== '01/01/0001' && s !== '01/01/1900') {

      s = s.trim();

      let i = s.lastIndexOf('/');

      // format not found return default date
      if (i !== -1) {
        let year = s.substr(i + 1);
        let date = new Date(s);

        let currentYear = new Date().getFullYear();
        if (date.getFullYear() > currentYear && year.length === 2) {
          date.setFullYear(date.getFullYear() - 100);
        }

        strDate = formatDate(date, 'MM/dd/yyyy', 'en-US');
      }
    }

    return strDate;
  }

  // init flatfile importer
  initializeImporter() {

    FlatfileImporter.setVersion(2);
    //this.brandSelectOptions = this.brands.map(b => ({ value: b.name, label: b.name }));
    //this.campaignSelectOptions = this.campaignTypes.map(b => ({ value: b.name, label: b.name }));

    this.importer = new FlatfileImporter(environment.flatFileLicenseKey, {
      fields: this.getFlatfileFields(),
      //title: 'Import mailing records',
      type: 'MailingRecord',
      allowCustom: false,
      //maxRecords: 10000, 
      allowInvalidSubmit: true,
      managed: true, // set to true to allow xls files to be imported.
      disableManualInput: true,
      devMode: (!environment.production),
      styleOverrides: {
        borderRadius: '4px',
        primaryButtonColor: '#289cbf',
        primaryButtonBorderColor: '#1f7a95',
        primaryButtonFontSize: '1.6rem',
        primaryButtonFontColor: '#fff',
        secondaryButtonColor: '#8b99a4',
        secondaryButtonBorderColor: '#8b99a4',
        secondaryButtonFontSize: '1.6rem',
        secondaryButtonFontColor: '#fff',
        linkColor: '#289cbf',
        linkAltColor: '#4a90e2',
        primaryTextColor: '#1D2830',
        secondaryTextColor: '#667d8d',
        errorColor: '#ff4c42',
        successColor: '#60b700',
        warningColor: '#f6A623',
        borderColor: '#e8e8e8',
        fontFamily: 'Gilroy, "Helvetica Neue", Arial, sans-serif'
      }
    });

    // set file user info
    this.importer.setCustomer({
      userId: this.userId,
      name: this.userName
    });

    //// multi-field validation
    //this.importer.registerRecordHook(record => {

    //  //let out = {
    //  //  "dateOfBirth": { value: record.brandName, info: [{ message: '', level: '' }] },
    //  //  "lastExamDate": { value: record.campaignType, info: [{ message: '', level: '' }] }
    //  //};

    //  // format birthdate
    //  if (record.dateOfBirth) {
    //    out.dateOfBirth = {
    //      value: this.convertDate(record.dateOfBirth),
    //      info: [
    //        {
    //          message: "Invalid date",
    //          level: "info"
    //        }
    //      ]
    //    } 
    //  }

    //  return out;

    //let out = {
    //  //"brandName": { value: record.brandName, info: [{ message: '', level: '' }] },
    //  //"campaignType": { value: record.campaignType, info: [{ message: '', level: '' }] },
    //  "gender": { value: record.gender, info: [{ message: '', level: '' }] } 
    //};

    //// format gender
    //out.gender = {
    //  info: [
    //    {
    //      message: "converted gender",
    //      level: "warning"
    //    }
    //  ],
    //  value: this.convertGender(record.gender)
    //}

    //validate brand
    //if (!this.brands.some((item) => item.name === record.brandName)) {

    //  out.brandName = {
    //    info: [
    //      {
    //        message: "Invalid brand name",
    //        level: "error"
    //      } 
    //    ],
    //    value: record.brandName
    //  } 
    // }

    // validate campaign
    //if (!this.campaignTypes.some((item) => item.name.toLowerCase() === record.campaignType.toLowerCase())) {
    //  out.campaignType = {
    //    info: [
    //      {
    //        message: "Invalid campaign type",
    //        level: "error"
    //      }
    //    ],
    //    value: record.campaignType
    //  } 
    //}

    //// format zip
    //if (record.zipCode && record.zipCode.length > 5) {
    //  out.zipCode = {
    //    value: record.zipCode,
    //    info: [
    //      {
    //        message: "Invalid zip code format",
    //        level: "error"
    //      }
    //    ]
    //  }
    //} 


    //  })

  }


  // filter 
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // show notification popup
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
  }

}

